module.exports = __webpack_public_path__ + "static/img/no-authorized.3ded8873.png";